module.exports = __webpack_public_path__ + "static/media/buy-title.c55f1d0d.png";